import { Skeleton } from '@teach/ui'

interface Props {
  /** Number of placeholder cards to render. */
  count: number
  /** Grid layout classes (columns/gap) applied to the wrapper. */
  className?: string
}

/** Loading placeholder grid of course cards. Shared by Dashboard and Catalog. */
export const CourseCardSkeletonGrid = ({ count, className }: Props) => (
  <div className={className}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="rounded-[20px] bg-foreground/5 p-1 pb-3.5">
        <Skeleton className="aspect-video rounded-[14px]" />
        <div className="space-y-2 px-1.5 pt-3">
          <Skeleton className="h-5 w-4/5" />
          <Skeleton className="h-4 w-1/3" />
        </div>
      </div>
    ))}
  </div>
)
